import React, { useState } from 'react'
import { FiChevronDown } from 'react-icons/fi'

interface AccordionItemProps {
    title: string
    children: React.ReactNode
    defaultOpen?: boolean
    icon?: React.ReactNode
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
    title,
    children,
    defaultOpen = false,
    icon
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full px-4 sm:px-6 py-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
                <div className="flex items-center gap-2 sm:gap-3">
                    {icon && <span className="text-gray-600 dark:text-gray-400 flex-shrink-0">{icon}</span>}
                    <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-white text-left">
                        {title}
                    </h2>
                </div>
                <FiChevronDown
                    className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 flex-shrink-0 ${
                        isOpen ? 'transform rotate-180' : ''
                    }`}
                />
            </button>
            
            {isOpen && (
                <div className="px-4 sm:px-6 pb-4 border-t border-gray-200 dark:border-gray-700">
                    <div className="pt-4">
                        {children}
                    </div>
                </div>
            )}
        </div>
    )
}

interface AccordionProps {
    children: React.ReactNode
    className?: string
}

export const Accordion: React.FC<AccordionProps> = ({ children, className = '' }) => {
    return (
        <div className={`space-y-3 sm:space-y-4 ${className}`}>
            {children}
        </div>
    )
}
